module.exports = __webpack_public_path__ + "static/media/hero-1.9e04ff82.jpg";